var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5C9.5 5.27614 9.72386 5.5 10 5.5C10.2761 5.5 10.5 5.27614 10.5 5V3C10.5 2.44772 10.0523 2 9.5 2H7.5C7.22386 2 7 2.22386 7 2.5C7 2.77614 7.22386 3 7.5 3L8.79289 3L5.64645 6.14645C5.45118 6.34171 5.45118 6.65829 5.64645 6.85355C5.84171 7.04882 6.15829 7.04882 6.35355 6.85355L9.5 3.70711V5Z",
    fill: "#2A85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3.5C1.5 2.67157 2.17157 2 3 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3C2.72386 3 2.5 3.22386 2.5 3.5V9.5C2.5 9.77614 2.72386 10 3 10H9C9.27614 10 9.5 9.77614 9.5 9.5V7C9.5 6.72386 9.72386 6.5 10 6.5C10.2761 6.5 10.5 6.72386 10.5 7V9.5C10.5 10.3284 9.82843 11 9 11H3C2.17157 11 1.5 10.3284 1.5 9.5V3.5Z",
    fill: "#2A85FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabOpen);
export default __webpack_public_path__ + "static/media/tab_open.5ed45bc1adefe53ff2b6fc680f6115e9.svg";
export { ForwardRef as ReactComponent };